import React, { useEffect, useState } from "react";
import Center from "../../../../widget/common/ui/Center";
import Div from "../../../../widget/common/ui/Div";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { Col } from "react-bootstrap";
import { SignupCompanyLogo } from "../widget/SignupWidgets";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import PincodeInput from "../../../../widget/common/ui/PincodeInput";
import Countdown from "../../../../widget/common/ui/Coundown";
import { ButtonSingle } from "../../../../widget/common/form/Button";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { SignupAccountVerificationContextImport } from "../../../../provider/onboarding/signup/account_verification/SignupAccountVerificationContextProvider";
import Loader from "../../../../widget/common/ui/Loader";
import { routeName as routeNameSignupVerification } from "./SignupAccountVerificationScreen";

const SignupAccountVerificationContent = (props: { type: number }) => {
  const type: number = props.type;

  const {
    sendPin,
    resendVerification,
    updateCountDownStatus,
    pincodeLength,
    countDownStatus,
    verificationDetail,
    verificationType,
    screenName,
  } = SignupAccountVerificationContextImport();

  const [code, setCode] = useState<string>("");
  const [pinReset, setPinReset] = useState<boolean>(false);

  const completedTimer = () => {
    updateCountDownStatus(false);
    setPinReset(true);

    setInterval(() => {
      setPinReset(false);
    }, 500);
  };

  let mobileNumber: string = verificationDetail?.mobile_number ?? "";
  if (UtilityHelper.isNotEmpty(mobileNumber)) {
    mobileNumber = UtilityHelper.maskPhoneNumber(mobileNumber);
  }

  useEffect(() => {
    sendPin(code);
    // eslint-disable-next-line
  }, [code]);

  return (
    <Div className="h-100 d-center">
      {verificationDetail == null ? (
        <Center className="py-5">{Loader.normal()}</Center>
      ) : (
        <Div>
          <Center>
            <SignupCompanyLogo
              title={AppTranslation.text("account_verification")}
            />
          </Center>
          <Col xs={12} sm={8} className="mx-auto text-center">
            <Center>
              <TextBlock
                fontName="book"
                fontSize="16_17"
                textColor="theme-sublabel"
              >
                {screenName === routeNameSignupVerification ? (
                  <>
                    {verificationType === "email" ? (
                      <>
                        <span className="pe-1">
                          {AppTranslation.text("please_enter_email_address")}
                        </span>
                        {UtilityHelper.maskName(
                          verificationDetail?.email?.split("@")[0]!
                        )}
                        @{verificationDetail?.email?.split("@").at(-1)}
                      </>
                    ) : (
                      <>
                        <span className="pe-1">
                          {AppTranslation.text("please_enter_mobile_number")}
                        </span>
                        {mobileNumber}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {verificationType === "email" ? (
                      <>
                        <span className="pe-1">
                          {AppTranslation.text("please_enter_email_address")}
                        </span>
                        {verificationDetail?.email}
                      </>
                    ) : (
                      <>
                        <span className="pe-1">
                          {AppTranslation.text("please_enter_mobile_number")}
                        </span>
                        {verificationDetail?.mobile_number ?? ""}
                      </>
                    )}
                  </>
                )}
              </TextBlock>
            </Center>
            <SpacingHeight value={type === 1 ? 40 : type === 2 ? 50 : 60} />
            {!countDownStatus ? (
              <ButtonSingle
                handleClick={() => resendVerification()}
                width={200}
                className="mb-2"
              >
                {AppTranslation.text("resend")}
              </ButtonSingle>
            ) : (
              <>
                <PincodeInput
                  length={pincodeLength}
                  onChange={setCode}
                  resetStatus={pinReset}
                />
                <SpacingHeight value={13} />
                <TextBlock
                  fontName="book"
                  fontSize="16_17"
                  textColor="theme-sublabel"
                >
                  {/*  <Countdown duration={duration} /> */}
                  <Countdown onComplete={() => completedTimer()} />
                </TextBlock>
              </>
            )}

            <SpacingHeight value={40} />
          </Col>
        </Div>
      )}
    </Div>
  );
};

export default SignupAccountVerificationContent;
